
import { Badge  } from '@arco-design/web-react'
import './index.less'

export default function NewBadge(props) {
  return <Badge {...props} dotClassName="redqueenBadge" max={props.max || 99}/>
}
